import { useForceUpdate, useInterval } from '@mantine/hooks'

export const useCountdown = () => {
  const forceUpdate = useForceUpdate()

  useInterval(forceUpdate, 500, {
    autoInvoke: true,
  })
}
